export enum ValidationTrigger {
  OnBlur = 'onBlur',
  OnChange = 'onChange',
}
